import React, { useEffect, useState } from 'react';
import './App.css';
import pinkTheme from './util/theme/pinkTheme';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import ModeSwitch from './Components/ModeSwitch';
import { BrowserRouter as Router} from 'react-router-dom';
import RoutedApp from './Components/RoutedApp';
import { NotificationContainer } from './util/hooks/notify/Notification';

function App() {
  const [mode, setMode] = useState<'light' | 'dark'>(
    (localStorage.getItem('mode') as 'light' | 'dark') || 'light'
  );

  const toggleMode = () => {
    setMode((prevMode) => {
      const newMode = prevMode === 'light' ? 'dark' : 'light';
      localStorage.setItem('mode', newMode);
      return newMode;
    });
  };

  return (
    <ThemeProvider theme={pinkTheme(mode)}>
      <CssBaseline />
      {/*<ModeSwitch mode={mode} toggleMode={toggleMode} />*/}
      <NotificationContainer />
      <Router>
        <RoutedApp />
      </Router>
    </ThemeProvider>
  );
}

export default App;